// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df985e81","455":"60356e44","977":"5fe2ee15"}[chunkId] + ".chunk.js";
};